export const SITE = {
  name: "Yupi Burger",
  domain: "https://yupiburger.com",
  tagline: "Kenyalnya Seru, Lapis Demi Lapis!",
  company: "PT Yupi Indo Jelly Gum Tbk",
  official: {
    store: "https://www.yupilandstore.com/",
    storeLabel: "Yupiland Official Store",
    corporate: "https://www.yupi.co.id/",
    brand: "https://yupiland.com/",
    instagram: "https://www.instagram.com/yupi.gummy/",
  },
};

export const NAV = [
  { path: "/", label: "Beranda", testid: "navbar-link-beranda" },
  { path: "/produk/", label: "Produk", testid: "navbar-link-produk" },
  { path: "/tentang/", label: "Tentang", testid: "navbar-link-tentang" },
  { path: "/beli/", label: "Dimana Beli", testid: "navbar-link-beli" },
  { path: "/faq/", label: "FAQ", testid: "navbar-link-faq" },
];

export const ROUTES = [
  {
    path: "/",
    name: "Beranda",
    title: "Yupi Burger — Gummy Burger Ikonik Indonesia, Kenyal Lapis Demi Lapis",
    description:
      "Yupi Burger, permen gummy berbentuk burger legendaris dari Yupi. Kenyal, manis, halal, dan seru dimakan lapis demi lapis. Lihat varian dan tempat belinya di sini.",
    schema: "home",
  },
  {
    path: "/produk/",
    name: "Produk",
    title: "Produk Yupi Burger — Classic, Burger Max & Gummy Love Burger",
    description:
      "Kenali varian Yupi Burger: gummy burger klasik, Yupi Burger Max yang lebih besar, dan Yupi Gummy Love Burger edisi spesial. Semuanya kenyal, manis, dan halal.",
    schema: "produk",
  },
  {
    path: "/tentang/",
    name: "Tentang",
    title: "Tentang Yupi Burger & PT Yupi Indo Jelly Gum Tbk",
    description:
      "Cerita di balik Yupi Burger, gummy burger ikonik buatan PT Yupi Indo Jelly Gum Tbk — produsen gummy asal Indonesia yang berdiri sejak 1996 dan tersertifikasi halal.",
    schema: "tentang",
  },
  {
    path: "/beli/",
    name: "Dimana Beli",
    title: "Dimana Beli Yupi Burger — Toko Resmi & Minimarket Terdekat",
    description:
      "Beli Yupi Burger di Yupiland Official Store, minimarket seperti Alfamart dan Indomaret, serta toko kelontong dan supermarket di seluruh Indonesia.",
    schema: "beli",
  },
  {
    path: "/faq/",
    name: "FAQ",
    title: "FAQ Yupi Burger — Halal, Varian, Harga & Tempat Beli",
    description:
      "Jawaban pertanyaan seputar Yupi Burger: status halal, varian produk, cara menikmati, harga, dan di mana membelinya.",
    schema: "faq",
  },
];

export const LAYERS = [
  {
    id: "bun-top",
    testid: "layer-widget-layer-bun-top",
    name: "Bun Atas (Roti Gummy)",
    color: "#FF9F1C",
    flavor: "Aroma buah manis yang segar dengan kenyal pas di gigitan pertama.",
    fact: "Lapisan pelindung kelezatan Yupi Burger — lengkap dengan taburan wijen gummy di atasnya.",
  },
  {
    id: "lettuce",
    testid: "layer-widget-layer-lettuce",
    name: "Selada Gummy Hijau",
    color: "#2EC4B6",
    flavor: "Sensasi buah segar dengan keseimbangan asam-manis yang ringan.",
    fact: "Lapisan hijau ikonik yang bikin Yupi Burger mirip burger sungguhan.",
  },
  {
    id: "cheese",
    testid: "layer-widget-layer-cheese",
    name: "Keju Gummy Kuning",
    color: "#FFD166",
    flavor: "Sentuhan rasa buah lembut yang melengkapi lapisan lainnya.",
    fact: "Teksturnya super elastis — seru ditarik pelan-pelan sebelum dikunyah.",
  },
  {
    id: "patty",
    testid: "layer-widget-layer-patty",
    name: "Patty Gummy Merah",
    color: "#E63946",
    flavor: "Rasa buah berry yang juicy — lapisan paling tebal dan paling kenyal.",
    fact: "Bisa dimakan terpisah atau digabung lapisan lain untuk ledakan rasa maksimal.",
  },
  {
    id: "bun-bottom",
    testid: "layer-widget-layer-bun-bottom",
    name: "Bun Bawah (Roti Gummy)",
    color: "#FF9F1C",
    flavor: "Fondasi kenyal yang mengunci semua kombinasi rasa buah.",
    fact: "Paling asyik disimpan buat gigitan penutup yang terakhir.",
  },
];

export const PRODUCTS = [
  {
    id: "classic",
    testid: "product-card-yupi-burger-classic",
    name: "Yupi Burger",
    variant: "classic",
    badge: "Paling Ikonik",
    tagline: "Gummy burger mini yang melegenda",
    description:
      "Permen gummy berbentuk burger mini dengan lapisan roti, selada, keju, dan patty yang kenyal. Manisnya pas, bentuknya lucu, dan seru dimakan lapis demi lapis.",
    texture: "Kenyal lembut dengan gigitan ringan",
    layers: "Lima lapisan gummy warna-warni",
    cocok: "Camilan harian, bekal sekolah, dan isian goodie bag",
  },
  {
    id: "max",
    testid: "product-card-yupi-burger-max",
    name: "Yupi Burger Max",
    variant: "max",
    badge: "Ukuran Jumbo",
    tagline: "Lebih besar, lebih puas",
    description:
      "Versi jumbo dari Yupi Burger klasik. Ukurannya lebih besar sehingga bisa dimakan utuh langsung, atau dilepas lapis demi lapis sampai puas.",
    texture: "Ekstra tebal dan ekstra kenyal",
    layers: "Lapisan lebih tebal dari versi klasik",
    cocok: "Buat yang kurang puas dengan ukuran mini",
  },
  {
    id: "love",
    testid: "product-card-yupi-love-burger",
    name: "Yupi Gummy Love Burger",
    variant: "love",
    badge: "Edisi Spesial",
    tagline: "Gummy burger penuh cinta",
    description:
      "Varian spesial bertema cinta dari keluarga Yupi Burger. Cocok untuk hadiah kecil, hadir di momen spesial, atau kejutan manis untuk orang tersayang.",
    texture: "Kenyal dengan rasa buah yang lembut",
    layers: "Lapisan gummy bernuansa ceria",
    cocok: "Hadiah, hampers, dan momen spesial",
  },
];

export const FAQS = [
  {
    id: "bukan-restoran",
    testid: "faq-accordion-bukan-restoran",
    q: "Apakah Yupi Burger itu restoran atau burger sungguhan?",
    a: "Bukan. Yupi Burger adalah permen gummy (kembang gula lunak jeli) berbentuk burger mini yang diproduksi oleh PT Yupi Indo Jelly Gum Tbk. Meskipun bentuknya mirip burger lengkap dengan roti, selada, keju, dan patty, semuanya terbuat dari gummy yang manis dan kenyal.",
  },
  {
    id: "halal",
    testid: "faq-accordion-halal",
    q: "Apakah Yupi Burger halal?",
    a: "Ya. Produk Yupi, termasuk Yupi Burger, telah tersertifikasi halal dari MUI dan BPJPH, serta terdaftar di BPOM. Kamu bisa mengecek label halal yang tertera pada kemasan produk.",
  },
  {
    id: "varian",
    testid: "faq-accordion-varian",
    q: "Apa saja varian Yupi Burger?",
    a: "Ada tiga varian yang bisa kamu temukan: Yupi Burger klasik berukuran mini, Yupi Burger Max yang ukurannya lebih besar, dan Yupi Gummy Love Burger edisi spesial bertema cinta.",
  },
  {
    id: "dimana-beli",
    testid: "faq-accordion-dimana-beli",
    q: "Di mana bisa membeli Yupi Burger?",
    a: "Yupi Burger mudah ditemukan di minimarket seperti Alfamart dan Indomaret, toko kelontong, warung, dan supermarket di seluruh Indonesia. Untuk belanja online, kunjungi Yupiland Official Store atau toko resmi Yupi di marketplace favoritmu.",
  },
  {
    id: "harga",
    testid: "faq-accordion-harga",
    q: "Berapa harga Yupi Burger?",
    a: "Harga jual bisa berbeda-beda di setiap toko dan platform penjualan. Untuk harga terkini, cek langsung di Yupiland Official Store atau toko terdekat di kotamu.",
  },
  {
    id: "cara-makan",
    testid: "faq-accordion-cara-makan",
    q: "Bagaimana cara paling seru makan Yupi Burger?",
    a: "Ada dua cara paling populer: gigit langsung seperti makan burger sungguhan, atau lepas dan nikmati lapis demi lapis — roti, selada, keju, lalu patty-nya. Dua-duanya sama-sama seru!",
  },
  {
    id: "cara-simpan",
    testid: "faq-accordion-cara-simpan",
    q: "Bagaimana cara menyimpan Yupi Burger?",
    a: "Simpan di tempat yang sejuk dan kering, jauh dari sinar matahari langsung dan suhu panas agar tekstur kenyalnya tetap terjaga. Tutup kembali kemasan dengan rapat setelah dibuka.",
  },
  {
    id: "produsen",
    testid: "faq-accordion-produsen",
    q: "Siapa yang memproduksi Yupi Burger?",
    a: "Yupi Burger diproduksi oleh PT Yupi Indo Jelly Gum Tbk, produsen gummy asal Indonesia yang berdiri sejak 1996 dan berkantor pusat di Gunung Putri, Kabupaten Bogor, Jawa Barat. Produk Yupi kini diekspor ke lebih dari 40 negara.",
  },
];
